import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useDrag, useDrop } from 'react-dnd';

const style = {
  cursor: 'move',
};
function ColumnDragTR({ colEle, colIndex, handleEdit, handleColumnDelete, moveTr, id, handleActiveInactive }) {
  const { t } = useTranslation('common');
  const ref = useRef(null);

  const [{ handlerId }, drop] = useDrop({
    accept: 'card',
    collect(monitor) {
      return {
        handlerId: monitor.getHandlerId(),
      };
    },
    hover(item, monitor) {
      if (!ref.current) {
        return;
      }
      const dragIndex = item.index;
      const hoverIndex = colIndex;
      // Don't replace items with themselves
      if (dragIndex === hoverIndex) {
        return;
      }
      // Determine rectangle on screen
      const hoverBoundingRect = ref.current?.getBoundingClientRect();
      // Get vertical indexdle
      const hoverindexdleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
      // Determine mouse position
      const clientOffset = monitor.getClientOffset();
      // Get pixels to the top
      const hoverClientY = clientOffset.y - hoverBoundingRect.top;
      // Only perform the move when the mouse has crossed half of the items height
      // When dragging downwards, only move when the cursor is below 50%
      // When dragging upwards, only move when the cursor is above 50%
      // Dragging downwards
      if (dragIndex < hoverIndex && hoverClientY < hoverindexdleY) {
        return;
      }
      // Dragging upwards
      if (dragIndex > hoverIndex && hoverClientY > hoverindexdleY) {
        return;
      }
      // Time to actually perform the action
      moveTr(dragIndex, hoverIndex);
      // Note: we're mutating the monitor item here!
      // Generally it's better to avoid mutations,
      // but it's good here for the sake of performance
      // to avoid expensive index searches.
      item.index = hoverIndex;
    },
  });
  const [{ isDragging }, drag] = useDrag({
    type: 'card',
    item: () => {
      return { id, colIndex };
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });
  drag(drop(ref));
  const opacity = isDragging ? 0.5 : 1;

  return (
    <tr key={colEle} style={{ ...style, opacity }} data-handler-id={handlerId} ref={ref}>
      <td className="text-center">
        <span className="icon-Rearrange f-20" />
      </td>
      <td>{colEle?.fieldName}</td>
      <td>{colEle?.label}</td>
      <td>
        <div className="table-action-container">
          <button className="btn p-0 d-inline-flex" title={t('CUSTOM_MODULE.EDIT_COLUMN')} onClick={() => handleEdit(colIndex)} type="submit">
            <i className="icon-Edit-1 f-20" />
          </button>
          <button className="btn p-0 d-inline-flex" title={t('CUSTOM_MODULE.DELETE_COLUMN')} onClick={() => handleColumnDelete(colIndex)} type="submit">
            <i className="icon-Delete f-20" />
          </button>
          <button
            className="btn p-0 d-inline-flex"
            title={t('CUSTOM_MODULE.ACTIVE_INACTIVE_COLUMN')}
            onClick={() => handleActiveInactive(colIndex)}
            type="submit"
          >
            {'isActive' in colEle && !colEle?.isActive ? <span className="icon-Eye-Closed" /> : <span className="icon-Eye-Open" />}
          </button>
        </div>
      </td>
    </tr>
  );
}

export default ColumnDragTR;
